import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/A5';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得單筆增額投資金額申請條款說明
export function getAgreeTermsA5() {
    return get(`${url}/getAgreeTerms`);
};

// 單筆增額投資金額申請條款同意
export function postAgreeA5() {
    return post(`${url}/agree`);
};

/**
 * 保戶進入單筆增額投資金額申請前，取得先前單筆增額投資金額申請記錄
 * @return {Object}
 */
export function getInfoA5() {
    return get(`${url}/info`);
};

/**
 * 保戶進入單筆增額投資金額申請，取得投資標的公司及投資標的名稱下拉式選單
 * @return {Object}
 */
export function getFundBankInfoA5() {
    return get(`${url}/fundBankInfo`);
};

/**
 * 送出單筆增額投資金額申請
 * @return {Object}
 */
export function submitA5(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
};

/**
 * 送出單筆增額投資金額申請-資金來源及財務狀況
 * @return {Object}
 */
export function submitSourceA5(data) {
    return post(`${url}/submitSource`, data, { ...options, repeatRequestCancel: true });
};


/**
 * 送出單筆增額投資金額申請-顯示申購手續費
 * @return {Object}
 */
export function fundCodeInfo(data){
    return post(`${url}/fundCodeInfo`,data,{ ...options,repeatRequestCancel : true});
};
